"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _grommet = require("grommet");

var _HeaderModule = _interopRequireDefault(require("./Header.module.css"));

var staticImages = _interopRequireWildcard(require("../staticImages"));

var _Heart = _interopRequireDefault(require("./Heart"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Header = /*#__PURE__*/function (_React$Component) {
  _inherits(Header, _React$Component);

  var _super = _createSuper(Header);

  function Header() {
    _classCallCheck(this, Header);

    return _super.apply(this, arguments);
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      var _this = this;

      var image = this.props.info.logo;

      if (!image) {
        image = this.props.info.album[0];
      }

      if (window.innerWidth <= 767) {
        return /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
          height: "42px",
          background: this.props.color,
          style: {
            position: "absolute",
            top: "0px",
            left: "0px",
            right: "0px"
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _HeaderModule["default"].mobileHeart
        }, /*#__PURE__*/_react["default"].createElement(_Heart["default"], {
          token: this.props.token,
          email: this.props.email,
          clubUUID: this.props.info.uuid,
          heart: this.props.info.favorited,
          empty: staticImages.EMPTY_HEART_WHITE,
          filled: staticImages.FILLED_HEART,
          opacity: "1.0",
          heartFn: this.props.heartFn
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _HeaderModule["default"].clubNameMobile
        }, this.props.info.name), /*#__PURE__*/_react["default"].createElement("img", {
          src: staticImages.CLOSE,
          alt: "x",
          className: _HeaderModule["default"].closeImgMobile,
          onClick: function onClick() {
            return _this.props.changeWindowSize("off");
          }
        }));
      } else {
        return /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
          height: "75px",
          round: {
            size: "25px",
            corner: "top"
          },
          background: this.props.color,
          style: {
            position: "absolute",
            top: "0px",
            left: "0px",
            right: "0px"
          }
        }, /*#__PURE__*/_react["default"].createElement(_grommet.Avatar, {
          background: "#ffffff",
          src: image,
          size: "48px",
          style: {
            background: '#ffffff',
            position: "absolute",
            top: "15px",
            left: "25px"
          }
        }), /*#__PURE__*/_react["default"].createElement(_grommet.Avatar, {
          background: "#ffffff",
          src: image,
          size: "48px",
          style: {
            position: "absolute",
            top: "15px",
            left: "25px"
          }
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _HeaderModule["default"].clubName
        }, this.props.info.name), /*#__PURE__*/_react["default"].createElement("div", {
          className: _HeaderModule["default"].clubTag
        }, this.props.info.tag), /*#__PURE__*/_react["default"].createElement("img", {
          src: staticImages.CLOSE,
          alt: "x",
          className: _HeaderModule["default"].closeImg,
          onClick: function onClick() {
            return _this.props.changeWindowSize("off");
          }
        }), this.props.adminState === "Needs Approval" || this.props.adminState === "Change Reviews" ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          id: _HeaderModule["default"].approve_div,
          onClick: function onClick() {
            _this.props.changeWindowSize("off");

            _this.props.reactToSubmission("approve", _this.props.info.uuid, null);
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _HeaderModule["default"].approve
        }, "Approve & Publish"), /*#__PURE__*/_react["default"].createElement("img", {
          src: staticImages.APPROVE,
          id: _HeaderModule["default"].application,
          alt: "approve icon"
        })), /*#__PURE__*/_react["default"].createElement("div", {
          id: _HeaderModule["default"].reject_div,
          onClick: function onClick() {
            return _this.props.changeEmailPopup("reject");
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _HeaderModule["default"].reject
        }, "Reject"), /*#__PURE__*/_react["default"].createElement("img", {
          src: staticImages.CLOSE,
          alt: "x",
          id: _HeaderModule["default"].reject_icon
        }))) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _HeaderModule["default"].heartImg
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _HeaderModule["default"].heart
        }, /*#__PURE__*/_react["default"].createElement(_Heart["default"], {
          token: this.props.token,
          email: this.props.email,
          clubUUID: this.props.info.uuid,
          heart: this.props.info.favorited,
          empty: staticImages.EMPTY_HEART_WHITE,
          filled: staticImages.FILLED_HEART,
          opacity: "1.0",
          heartFn: this.props.heartFn
        }))), /*#__PURE__*/_react["default"].createElement("img", {
          src: staticImages.VERTICAL_BAR,
          alt: "",
          className: _HeaderModule["default"].verticalBarImg
        }), /*#__PURE__*/_react["default"].createElement("a", {
          href: "mailto:".concat(this.props.email)
        }, /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
          round: "8px",
          width: "128px",
          height: "32px",
          background: "white",
          className: _HeaderModule["default"].contactBox
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: staticImages.SEND_GREY,
          alt: "send",
          className: _HeaderModule["default"].sendImg
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _HeaderModule["default"].contactText,
          style: {
            color: "".concat(this.props.color)
          }
        }, "Contact Us")))));
      }
    }
  }]);

  return Header;
}(_react["default"].Component);

var _default = Header;
exports["default"] = _default;

//# sourceMappingURL=Header.js.map